import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appEmailMask]'
})
export class EmailMaskDirective {
  private readonly emailPattern = /^[a-zA-Z0-9._%+-]+@xxx\.com$/;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any): void {
    const input = this.el.nativeElement;
    const value = input.value;

    if (!this.emailPattern.test(value)) {
      input.setCustomValidity('El correo debe tener el formato: nombre@xxx.com');
    } else {
      input.setCustomValidity('');
    }
  }
}
